<template>
  <div class="carousel-container">
    <el-carousel class="d-none d-lg-block d-xl-block" style="height: 600px">
      <el-carousel-item
        v-for="item in pcLists"
        :key="item.title"
        style="height: 600px"
      >
        <el-image style="width: 100%; height: 600px" :src="item.imgUrl" />
        <div class="carousel-captions">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel
      class="d-sm-block d-md-block d-xl-none d-lg-none"
      style="height: 600px"
    >
      <el-carousel-item
        v-for="item in h5Lists"
        :key="item.title"
        style="height: 600px"
      >
        <el-image style="width: 100%; height: 600px" :src="item.imgUrl" />
        <div class="carousel-captions">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { reactive } from "vue";
export default {
  name: "CarouSel",
  setup() {
    const pcLists = reactive([
      {
        title: "超级合作节点火热招募",
        desc: "超高跑量、稳定收益、快联系我们吧！",
        imgUrl: require("@/assets/images/lunbo/bg01.jpg"),
      },
      {
        title: "加入柚米云",
        desc: "超多福利 技术答疑",
        imgUrl: require("@/assets/images/lunbo/bg01.jpg"),
      },
    ]);
    const h5Lists = reactive([
      {
        title: "超级合作节点火热招募h5",
        desc: "超高跑量、稳定收益、快联系我们吧！",
        imgUrl: require("@/assets/images/lunbo/index01.jpg"),
      },
      {
        title: "加入柚米云h5",
        desc: "超多福利 技术答疑",
        imgUrl: require("@/assets/images/lunbo/index01.jpg"),
      },
    ]);

    return { pcLists, h5Lists };
  },
};
</script>

<style lang="scss" scoped>
.carousel-captions {
  position: absolute;
  right: 15%;
  top: 100px;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
  h2 {
    font-weight: 600;
  }
  p {
    font-size: 20px;
    font-weight: 600;
    color: #ff881d;
    margin-top: 4px;
    margin-bottom: 16px;
  }
}

@media screen and (max-width: 768px) {
  #carouselExampleDark {
    .carousel-inner {
      width: 100%;
      height: 544px;
      background-color: #0d0f30;
      overflow: hidden;
      .carousel-item {
        height: 100%;
        display: flex;
        align-items: center;
        background: url("@/assets/images/lunbo/bg01.png") left -27.33333vw top 0/154.66667vw
          53.6vw no-repeat;
        img {
          width: 88vw;
          height: 80vw;
        }
        .carousel-captions {
          width: 100%;
          left: 0;
          right: 0;
          h2 {
            font-size: 30px;
          }
          p {
            margin-top: 300px;
          }
        }
      }
    }
  }
}
</style>